import { Helmet } from "react-helmet-async";

import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import PracticeTypeHero from "@/components/practiceType/PracticeTypeHero";
import PracticeRisks from "@/components/practiceType/PracticeRisks";
import RecommendedCoverage from "@/components/practiceType/RecommendedCoverage";
import PracticeTypeCaseStudies from "@/components/practiceType/PracticeTypeCaseStudies";
import PracticeTypeFAQ from "@/components/practiceType/PracticeTypeFAQ";
import CTASection from "@/components/CTASection";
import { getPracticeType } from "@/utils/practiceTypeData";
import { getOrganizationSchema, getBreadcrumbSchema } from "@/utils/seoSchemas";

const MVZPraxis = () => {
  const practiceType = getPracticeType("mvz")!;

  const breadcrumbSchema = getBreadcrumbSchema([
    { name: "Home", url: "https://praxis-versichert.de" },
    { name: "Cyberversicherung", url: "https://praxis-versichert.de/cyberversicherung" },
    { name: "MVZ" }
  ]);

  return (
    <>
      <Helmet>
        <title>{practiceType.title}</title>
        <meta name="description" content={practiceType.metaDescription} />
        <link rel="canonical" href="https://praxis-versichert.de/cyberversicherung/mvz" />
        
        <meta property="og:title" content={practiceType.title} />
        <meta property="og:description" content={practiceType.metaDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://praxis-versichert.de/cyberversicherung/mvz" />
        
        <script type="application/ld+json">
          {JSON.stringify(getOrganizationSchema())}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>

      <Navigation />
      
      <main>
        <PracticeTypeHero practiceType={practiceType} />
        <PracticeRisks practiceType={practiceType} />
        <RecommendedCoverage practiceType={practiceType} />
        <PracticeTypeCaseStudies practiceType={practiceType} />
        <PracticeTypeFAQ practiceType={practiceType} />
        <CTASection />
      </main>

      <Footer />
    </>
  );
};

export default MVZPraxis;
